/* eslint-disable no-unused-vars */
/* eslint-disable no-case-declarations */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-debugger */
import UilHdd from '@iconscout/react-unicons/icons/uil-hdd';
import moment from 'moment';
import { Badge, message } from 'antd';
import PropTypes from 'prop-types';
import React, { createRef, useEffect, useState } from 'react';
import { Scrollbars } from '@pezhmanparsaee/react-custom-scrollbars';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Howl } from 'howler';
import { UserActionDropDown } from './auth-info-style';
import Heading from '../../heading/heading';
import { Popover } from '../../popup/popup';
// import { registerObserver, unregisterObserver, useWebSocketManager } from '../../../config/websocketManager';
import { NOTIFICATION_TYPES, SOCKET_ACTIONS } from '../../../config/config';
import websocketManager from '../../../config/websocketManager';
import { NotificationDetailsDialog } from '../../../pages/common';
import { DataService } from '../../../config/dataService/dataService';

const popRef = createRef(null);

const NotificationBox = React.memo(() => {
  // const { getConnectionStatus, sendJsonMessage, getConnection } = useWebSocketManager();
  const [dataArray, setDataArray] = useState([])
  const [showDetails, setShowDetails] = useState(false);
  const [notiData, setNotiData] = useState(null);
  // const [audio] = useState(new Audio('https://waveform.envatousercontent.com/tsunami/472198703/preview.mp3'));
  const [notificationSound] = useState(new Howl({
    // src: [`${window.location.origin}/audio/notification.mp3`], // Use PUBLIC_URL for static assets
    src: [`${window.location.origin}/audio/notification.mp3`], // Use PUBLIC_URL for static assets
    html5: true, // Ensures compatibility across browsers
    preload: true
  }));

  const { rtl } = useSelector((state) => {
    return {
      rtl: state.ChangeLayoutMode.rtlData,
    };
  });


  function renderThumb({ style }) {
    const thumbStyle = {
      borderRadius: 6,
      backgroundColor: '#F1F2F6',
    };
    return <div style={{ ...style, ...thumbStyle }} />;
  }

  const renderTrackVertical = () => {
    const thumbStyle = {
      position: 'absolute',
      width: '6px',
      transition: 'opacity 200ms ease 0s',
      opacity: 0,
      [rtl ? 'left' : 'right']: '2px',
      bottom: '2px',
      top: '2px',
      borderRadius: '3px',
    };
    return <div className="hello" style={thumbStyle} />;
  };

  function renderView({ style }) {
    const customStyle = {
      marginRight: rtl && 'auto',
      [rtl ? 'marginLeft' : 'marginRight']: '-17px',
    };
    return <div style={{ ...style, ...customStyle }} />;
  }

  renderThumb.propTypes = {
    style: PropTypes.shape(PropTypes.object),
  };

  renderView.propTypes = {
    style: PropTypes.shape(PropTypes.object),
  };

  useEffect(() => {
    const handleAction = (data) => {
      try {

        switch (Number(data.event_id)) {
          case SOCKET_ACTIONS.FETCH_NOTIFICATIONS:
            websocketManager.sendJsonMessage({ event_id: SOCKET_ACTIONS.REQUEST_NEW_NOTIFICATIONS })
            break;
          case SOCKET_ACTIONS.RECEIVED_NEW_NOTIFICATIONS:
            data = data.data
            if (Boolean(data.status)) {
              const newNotifications = data.data;
              // const isNewNotification = newNotifications.some(
              //   (newNoti) => !dataArray.find((existingNoti) => existingNoti.id === newNoti.id)
              // );

              // Play sound only if there's a new notification
              if ((newNotifications.length > dataArray.length) && !notificationSound.playing()) {
                notificationSound.play();
              }
              // if (data.data.length > 0 && (data.data.length > dataArray.length)) {
              //   if (!notificationSound.playing()) notificationSound.play()
              // }
              setDataArray(newNotifications)
            }
            break;
          default:
            break;
        }
      } catch (error) {
        message.error(`Error handling socket message : ${error.message}`)
      }
      // console.log('Action_received:', data);
      // Perform action based on data
    };

    // Register for an action_id

    websocketManager.registerObserver(SOCKET_ACTIONS.FETCH_NOTIFICATIONS, handleAction);
    websocketManager.registerObserver(SOCKET_ACTIONS.RECEIVED_NEW_NOTIFICATIONS, handleAction);

    return () => {
      // Unregister the observer on component unmount
      websocketManager.unregisterObserver(SOCKET_ACTIONS.FETCH_NOTIFICATIONS, handleAction);
      websocketManager.unregisterObserver(SOCKET_ACTIONS.RECEIVED_NEW_NOTIFICATIONS, handleAction);
    };

  }, [dataArray]);

  const readNotiRequest = async (dataID) => {
    const response = await DataService.post('/common/noti/read-unread', {
      id: dataID,
      read_status: 1
    });

    const { status } = response.data;
    if (status) {
      websocketManager.sendJsonMessage({ event_id: SOCKET_ACTIONS.REQUEST_NEW_NOTIFICATIONS })
      // message.success(response.data.message)
    } else {
      message.error(response.data.message)
    }
  }

  const handleNotiClick = async (event) => {
    try {
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0)
      // alert(dataID)
      const dbRec = dataArray.find(item => item.id === dataID);
      if (dbRec) {
        await readNotiRequest(dataID)
        setNotiData(dbRec)
        setShowDetails(true)
        popRef.current.setPopupVisible(false);

      }
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
    }
  }

  const content = (
    <UserActionDropDown className="ninjadash-top-dropdown" onClick={() => {
      // alert('T')
    }}>
      <Heading as="h5" className="ninjadash-top-dropdown__title">
        <span className="title-text">Notifications</span>
        <Badge className="badge-success" count={dataArray.length} />
      </Heading>
      <Scrollbars
        autoHeight
        autoHide
        renderThumbVertical={renderThumb}
        renderView={renderView}
        renderTrackVertical={renderTrackVertical}
        renderTrackHorizontal={(props) => <div {...props} style={{ display: 'none' }} className="track-horizontal " />}
      >
        {dataArray.map(item =>
          <>
            <ul className="hover:drop-shadow-lg">
              <li className="border-1 border-blue-800 ">
                <Link
                  to='#'
                  onClick={handleNotiClick}
                  data-index={item.id}
                >
                  <div className="ninjadash-top-dropdown__content notifications ">
                    <div className="notification-icon ">
                      <UilHdd />
                    </div>
                    <div className="notification-content d-flex ">
                      <div className="notification-text ">
                        <Heading as="h5">
                          <span>{NOTIFICATION_TYPES[item.type_id]}</span>
                        </Heading>
                        <div className='text-[10px]'>
                          {item.description}
                        </div>
                        <p>{moment(item.created_at).fromNow()}</p>
                      </div>
                    </div>
                  </div>
                </Link>
              </li>
            </ul>
          </>
        )}
      </Scrollbars>
      {dataArray.length > 0 ? <Link className="btn-seeAll" to="notifications">
        See all incoming activity
      </Link> :
        <div className="flex flex-col items-center justify-center p-10 space-y-4 text-center text-gray-500">
          <div className="p-6">
            <img
              alt="No Notifications"
              src={require('../../../static/img/icon/no-notifications.png')}
              className="w-20 h-20 animate-bounce"
            />
          </div>
          <h3 className="text-xl font-semibold text-orange-500">No New Notifications</h3>
          <p className="text-sm text-gray-400 animate-pulse">
            You’re all caught up! Check back later for updates.
          </p>
        </div>
      }
    </UserActionDropDown>
  );

  return (
    <div className={`ninjadash-nav-actions__item ninjadash-nav-actions__notification ${dataArray.length > 0 ? 'animate-bounce' : ''}`}>
      <Popover popRef={popRef} placement="bottomLeft" ref={popRef} content={content} action="click" trigger='click'>
        <Badge dot offset={[-8, -5]}>
          <Link to="#" className="ninjadash-nav-action-link">
            <img alt='test' src={require('../../../static/img/icon/noti_bell.png')} style={{ height: 20, width: 20 }} />
          </Link>
        </Badge>
      </Popover>
      {/* <Popover placement="bottomLeft" content={content} action="click" visible={false}>
        <Badge dot offset={[-8, -5]}>
          <Link to="#" className="ninjadash-nav-action-link">
            <img alt='test' src={require('../../../static/img/icon/noti_bell.png')} style={{ height: 20, width: 20 }} />
          </Link>
        </Badge>
      </Popover> */}

      {showDetails && <NotificationDetailsDialog showDialog={setShowDetails} setReload={null} notiData={notiData} />}
    </div>
  );
});

export default NotificationBox;
